import React from "react";
import { useAccordionToggle } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setSummaryCollapsed } from "../../../actions/farm-monitor";
import { Icon } from "../../widgets";

export const SummaryToggle = ({ isRequesting, eventKey }) => {

    const isCollapsed = useSelector(state => state.farmMonitor.summaryToggleCollapsed);
    const dispatch = useDispatch();

    const decoratedOnClick = useAccordionToggle(eventKey, () => {
        dispatch(setSummaryCollapsed(!isCollapsed));
    });

    return (
        <span
            onClick={decoratedOnClick}
            className={`farm__toggle-icon ${isRequesting ? 'disabled' : ''}`}
        >
            <Icon className={`text-white fa-2x fa ${isCollapsed ? 'fa-angle-down' : 'fa-angle-up'}`} />
        </span>
    );
}